import { MOOD_TABLE } from 'constants/beautyFilterTables';
import useBeautiStore from 'stores/beautyFilter/beautiStore';
import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';
import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';

const beautyFilterBridge = {
  // main.js가 네이티브 GPU passthrough 여부(Device.isGpuPassthrough)를 받은 뒤 호출한다.
  // passthrough 여부를 inited보다 먼저 넣어야 useApplyBeautyFilter의 초기 적용이 passthrough 기기에서 Banuba 초기화를 건너뛴다.
  init: (gpuPassthrough: boolean) => {
    useBeautyFilterBanubaStore.getState().setGpuPassthrough(!!gpuPassthrough);
    useBeautyFilterStore.getState().setInited(true);
  },

  // device.js OnGpuPassthrough → 네이티브 GPU passthrough 여부
  setGpuPassthrough: (gpuPassthrough: boolean) => {
    useBeautyFilterBanubaStore.getState().setGpuPassthrough(gpuPassthrough);
  },

  isBeautyFilterModalVisible: () => {
    return useBeautyFilterStore.getState().isBeautyFilterModalVisible;
  },

  showBeautyFilterModal: (handler: any) => {
    useBeautyFilterStore.getState().showBeautyFilterModal(handler);
  },

  hideBeautyFilterModal: () => {
    useBeautyFilterStore.getState().hideBeautyFilterModal();
  },

  getMyBeauty: () => {
    const store = useBeautyFilterStore.getState();
    const { keys } = store.beauty;
    return keys.filter((key) => useBeautyFilterBanubaStore.getState().isBeautyKeyUsing(key));
  },

  getMyMakeup: () => {
    const store = useBeautyFilterStore.getState();
    const { keys } = store.makeup;
    return keys.filter((key) => useBeautyFilterBanubaStore.getState().isMakeupKeyUsing(key));
  },

  getMyMood: () => {
    const store = useBeautyFilterStore.getState();
    const { selectedKey } = store.mood;
    return selectedKey;
  },

  getMySticker: () => {
    const store = useBeautyFilterStore.getState();
    const { selectedKey } = store.sticker;
    return selectedKey || '';
  },

  // isUsing
  isUsingPreset: () => {
    return useBeautyFilterBanubaStore.getState().isUsingPreset();
  },
  isUsingBanuba: () => {
    return useBeautyFilterBanubaStore.getState().isUsingBanuba();
  },

  // roomui.js setBlurEffect 유해 감지 필터링을 위해 제공
  getMoodItem: (id: string) => {
    return MOOD_TABLE[id];
  },

  // Mood Device 관련 Beauti 셋팅
  setBeautiMode: (cameraNum: number) => {
    useBeautiStore.getState().setBeautiMode(cameraNum);
  },

  setBeautiType: (type: number) => {
    useBeautiStore.getState().setBeautiType(type);
  },

  // Banuba SDK 콜백 큐 시스템
  banubaCallbackQueue: {} as Record<number, (success: boolean) => void>,
  banubaReqId: 0,

  onBanubaApiEnded: (reqId: number, success: boolean) => {
    const callback = beautyFilterBridge.banubaCallbackQueue[reqId];
    if (callback) {
      callback(success);
      delete beautyFilterBridge.banubaCallbackQueue[reqId];
    }
  },
  isInitializedBanubaSdkAsync: () => {
    return new Promise((resolve) => {
      Device.isInitializedBanubaSdk((result: boolean) => {
        resolve(result);
      });
    });
  },
  initializeBanubaSdkAsync: () => {
    return new Promise((resolve) => {
      Device.initializeBanubaSdk((result: boolean) => {
        resolve(result);
      });
    });
  },
  isBanubaAssetDownloadedAsync: (assetName: string) => {
    return new Promise((resolve) => {
      Device.isBanubaAssetDownloaded(assetName, (_assetName: string, result: boolean) => {
        resolve(result);
      });
    });
  },
  downloadBanubaAssetResourceAsync: (assetName: string) => {
    return new Promise((resolve) => {
      Device.downloadBanubaAssetResource(assetName, (_assetName: string, progress: number) => {
        if (progress === -1) resolve(false);
        if (progress === 100) resolve(true);
      });
    });
  },
  setBanubaAsync: (assetName: string) => {
    return new Promise((resolve) => {
      const reqId = beautyFilterBridge.banubaReqId++;
      beautyFilterBridge.banubaCallbackQueue[reqId] = (result: boolean) => {
        resolve(result);
      };
      Device.setBanuba(reqId, assetName);
    });
  },
};

export default beautyFilterBridge;
